import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  getLoginSuccess,
  getLoginError,
  doLoginSuccess,
  doLoginError,
  referralCodeSuccess,
  referralCodeError,
  getLDCSuccess,
  getLDCError,
  confirmOTPSuccess,
  confirmOTPError,
  getCustomerDetailsError,
  getCustomerDetailsSuccess
} from "./actionLogin";
import {
  CONFIRM_OTP_REQUEST,
  DO_LOGIN,
  GET_LDC_REQUEST,
  PHONE_NUMBER_REQUEST,
} from "../../actionType";
import { fetchGet, fetchPost } from "../../../../utils/request";
import {
  P2P_LOGIN,
  VERYFY_NUMBER,
  HANDLE_REFERRAL_URL,
  LDC_CREATE_USER,
  LDC_VERIFY_USER,
  CUSTOMER_DETAILS_LANDING
} from "../../../../utils/urls";
import {
  setAuthToken,
  setMobileNo,
  getMobileNo,
  getStoreReferalCode,
  deleteReferalCode,
} from "../../../../utils/localStorage";

const stateValue = (state: any) => state.login;

function* getLogin(): any {
  try {
    const stateName = yield select(stateValue);
    const response = yield call(fetchPost, VERYFY_NUMBER, stateName.phone);
    if (response.status) {
      setMobileNo(stateName.phone.phone);
      return yield put(getLoginSuccess(response));
    }
    yield put(getLoginError("some error"));
  } catch (error) {
    yield put(getLoginError(error));
  }
}

function* doLogin(): any {
  try {
    const stateName = yield select(stateValue);
    const body = {
      phone: getMobileNo(),
      otp: stateName.otp,
    };
    const response = yield call(fetchPost, P2P_LOGIN, body);
    if (response.status) {
      if (response.results.client_token === "Invalid OTP") {
        yield put(doLoginError(response.results.client_token));
        return false;
      }
      if (response?.results?.client_token) {
        yield setAuthToken(response.results.client_token);
      } 
      // if (getStoreReferalCode() !== "null" && getStoreReferalCode() !== null)
      //   yield referralMethod();
      if(response?.results?.landing_page){
        yield fetchCustomerDetails(response?.results?.landing_page);
      }
      return yield put(doLoginSuccess(response));
    }
    let errorMessage = "";
    if(response.error){
      if(response?.error?.errors?.detail){
        errorMessage = response?.error?.errors?.detail;
      }
    }
    else if (response.errors.phone) errorMessage = "Invalid Phone Number";
    else if (response.errors.otp) errorMessage = "Invalid otp";
    yield put(doLoginError(errorMessage));
  } catch (error) {
    yield put(doLoginError("some error"));
  }
}

function* fetchCustomerDetails(landingPage:any): any {
  try {
      const response = yield call(fetchGet, CUSTOMER_DETAILS_LANDING + landingPage);
      if (response.error) {
          yield put(getCustomerDetailsError(response.error));
          return false;
      }
      if (response.status) {
          yield put(getCustomerDetailsSuccess(response));
          return true;
      }
  } catch (error) {
      yield put(getCustomerDetailsError(error))
  }
}

export function* referralMethod(): any {
  let body = {
    referral_code: getStoreReferalCode(),
  };
  try {
    const response = yield call(fetchPost, HANDLE_REFERRAL_URL, body);
    deleteReferalCode();
    return yield put(referralCodeSuccess(response.status));
  } catch (error) {
    yield put(referralCodeError(error));
  }
}

function* getLdcOTP(): any {
  try {
    const res = yield call(fetchPost, LDC_CREATE_USER, {});
    yield put(getLDCSuccess(res));
  } catch (error) {
    yield put(getLDCError(error));
  }
}

function* confirmLDCOTP(data: any): any {
  let body = {
    otp: data.value,
  };
  try {
    const response = yield call(fetchPost, LDC_VERIFY_USER, body);
    yield put(confirmOTPSuccess(response));
  } catch (error) {
    yield put(confirmOTPError(error));
  }
}

export default function* loginSaga() {
  yield all([
    takeLatest(PHONE_NUMBER_REQUEST, getLogin),
    takeLatest(DO_LOGIN, doLogin),
    takeLatest(GET_LDC_REQUEST, getLdcOTP),
    takeLatest(CONFIRM_OTP_REQUEST, confirmLDCOTP),
  ]);
}